import axios from "axios";

function getApiBase() {
  if (process.env.NODE_ENV === "development" && process.env.REACT_APP_BACKEND_URL) {
    return `${process.env.REACT_APP_BACKEND_URL}/api`;
  }
  return "/api";
}

export const API_BASE = getApiBase();

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  timeout: 30000,
});

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("mt5_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/login") && !err.config?.url?.includes("/auth/verify-mfa")) {
      localStorage.removeItem("mt5_token");
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    if (err.response?.status === 429) {
      const retryAfter = err.response.headers?.["retry-after"];
      err.rateLimited = true;
      err.userMessage = retryAfter
        ? `Too many requests — retry in ${retryAfter}s`
        : "Too many requests — please wait a moment";
    }
    return Promise.reject(err);
  }
);

export default api;

export function formatErr(detail) {
  if (detail == null) return "Something went wrong";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}

export function fmtMoney(n, currency = "USD") {
  if (n == null) return "—";
  const sign = n < 0 ? "-" : "";
  const abs = Math.abs(Number(n));
  return `${sign}$${abs.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtNum(n, d = 2) {
  if (n == null) return "—";
  return Number(n).toLocaleString("en-US", { minimumFractionDigits: d, maximumFractionDigits: d });
}
